module.exports = __webpack_public_path__ + "static/media/computer.f9eb7a5f.svg";